import { Close } from '@mui/icons-material'
import { FileUploadHeader, StyledTypography } from './ContainerImagesEditModalHeader.styles'

export const ContainerImagesEditModalHeader: React.FC<{
  labelText: string
  handleClose: () => void
}> = ({ labelText, handleClose }): JSX.Element => (
  <FileUploadHeader>
    <StyledTypography display={'block'}>{labelText}</StyledTypography>
    <Close onClick={handleClose} />
  </FileUploadHeader>
)
